import { render, staticRenderFns } from "./CalendarCrud.vue?vue&type=template&id=78950c74"
import script from "./CalendarCrud.vue?vue&type=script&lang=js"
export * from "./CalendarCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports